(function (root) {
  function samePath(a, b, base) {
    try { return decodeURIComponent(new URL(a, base).pathname) === decodeURIComponent(new URL(b, base).pathname); }
    catch (_) { return false; }
  }

  function relatedTarget(items, currentUrl, format, grind, base) {
    const current = items.find(item => samePath(item.Url, currentUrl, base));
    const type = format || current?.Type;
    const selectedGrind = ['kcups', 'steepbag'].includes(type) ? null : (grind || current?.Grind || 'ground');
    return items.find(item => item.Type === type && (item.Grind || null) === selectedGrind)
      || items.find(item => item.Type === type) || null;
  }

  function packCount(title) {
    if (/^\s*one\b/i.test(title || '')) return 1;
    return Number((String(title || '').match(/^\s*(\d+)/) || [])[1]) || 1;
  }
  function restoredQuantity(state, customAvailable = true, singleVariantAvailable = false) {
    return (state?.custom && customAvailable) || (state?.singleVariantQuantity && singleVariantAvailable)
      ? Math.max(1, Number(state.quantity) || 1) : 1;
  }

  function incomingPurchaseState(href, product, currentVariantId) {
    let params;
    try { params = new URL(href).searchParams; } catch (_) { return null; }
    if (!params.has('quantity') && !params.has('selling_plan')) return null;
    const variantId = params.get('variant');
    const variant = product?.variants?.find(item => String(item.id) === variantId && item.available);
    if (!variant || String(currentVariantId) !== variantId) return null;
    const rawQuantity = params.has('quantity') ? params.get('quantity') : '1';
    const quantity = Number(rawQuantity);
    if (!/^\d+$/.test(rawQuantity) || !Number.isInteger(quantity) || quantity < 1 || quantity > 24) return null;
    const pack = packCount(variant.title);
    // Homepage custom quantity uses singles. Do not multiply a multi-pack through an incoming URL.
    if (pack !== 1 && quantity !== 1) return null;
    const plan = variant.allocations?.find(item => String(item.id) === params.get('selling_plan'));
    const weeks = Number((String(plan?.name || '').match(/\b(\d+)\s*weeks?\b/i) || [])[1]);
    const subscribed = !!plan && [4, 6, 8, 10, 12].includes(weeks);
    return { variantId, pack, quantity, custom: pack === 1 && quantity > 1, subscribed, weeks: subscribed ? weeks : null };
  }

  function singleVariantQuantityInput(scope) {
    const editor = scope?.querySelector('.custom-quantity__selector.single-variant');
    const form = scope?.querySelector('product-form form');
    const input = editor?.querySelector('[name="quantity"]');
    return editor?.getClientRects().length && input?.form === form ? input : null;
  }

  function targetUrl(input, current) {
    try {
      const url = new URL(input, current);
      const active = new URL(current);
      if (url.origin !== active.origin) return null;
      const preview = active.searchParams.get('preview_theme_id');
      if (preview && !url.searchParams.has('preview_theme_id')) url.searchParams.set('preview_theme_id', preview);
      return url;
    } catch (_) { return null; }
  }

  function validProductResponse(response, requested, base) {
    try {
      const expected = new URL(requested, base);
      const received = new URL(response.url, base);
      return response.ok && String(response.headers.get('content-type') || '').includes('text/html')
        && received.origin === expected.origin && samePath(received.href, expected.href, base);
    } catch (_) { return false; }
  }
  const navigationHeadSection = 'alac-pdp-navigation-head';
  function mainSectionIds(main) {
    const children = [...(main?.children || [])];
    if (!children.length || children.length > 20) return null;
    const ids = children.map(node => node.id?.startsWith('shopify-section-') ? node.id.slice('shopify-section-'.length) : null);
    return ids.every(id => id && /^[\w-]+$/.test(id)) && new Set(ids).size === ids.length ? ids : null;
  }
  function sectionRequestUrls(href, ids) {
    const list = [navigationHeadSection, ...ids];
    const urls = [];
    for (let offset = 0; offset < list.length; offset += 5) {
      const url = new URL(href);
      url.searchParams.delete('section_id');
      url.searchParams.set('sections', list.slice(offset, offset + 5).join(','));
      urls.push(url);
    }
    return urls;
  }
  function sectionPageHtml(sections, ids, href) {
    if (!sections || typeof sections !== 'object' || Array.isArray(sections)) throw new Error('Invalid section response');
    for (const id of [navigationHeadSection, ...ids]) {
      if (typeof sections[id] !== 'string' || !sections[id].trim()
        || !sections[id].includes('id="shopify-section-' + id + '"')) throw new Error('Missing product section');
    }
    const script = sections[navigationHeadSection].match(/<script\b[^>]*\bdata-alac-navigation-head[^>]*>([\s\S]*?)<\/script>/i);
    const metadata = JSON.parse(script?.[1] || 'null');
    if (!metadata || metadata.template !== 'product' || metadata.suffix !== ''
      || !/^\d+$/.test(String(metadata.productId)) || !samePath(metadata.url, href, href)
      || !samePath(metadata.canonical, href, href) || new URL(metadata.canonical, href).origin !== new URL(href).origin
      || typeof metadata.head !== 'string' || !metadata.head.trim()) throw new Error('Invalid product metadata');
    return '<!doctype html><html><head>' + metadata.head
      + '<meta name="alac-navigation-product-id" content="' + metadata.productId + '"></head><body><main id="MainContent">'
      + ids.map(id => sections[id]).join('') + '</main></body></html>';
  }
  function productPageContent(next, requested, base) {
    const nextMain = next.querySelector('main#MainContent');
    const nextRoot = nextMain && productRoot(nextMain);
    const nextProduct = nextRoot?.querySelector('[data-alac-product]');
    const nextPicker = nextRoot?.querySelector('.custom-picker__container-all .relatedItems-json');
    if (!nextMain || !nextRoot || !nextProduct || !nextPicker) throw new Error('Missing product content');
    const payload = JSON.parse(nextProduct.textContent);
    const picker = nextPicker.closest('.custom-picker__container-all');
    const related = JSON.parse(nextPicker.textContent).RelatedProducts;
    if (!samePath(productRoute(nextRoot), requested, base)
      || String(picker?.dataset.productid) !== String(payload.id)
      || !related?.some(item => samePath(item.Url, requested, base))) throw new Error('Mismatched product content');
    return { nextMain, nextRoot, payload };
  }
  function validateSectionPage(next, ids, href) {
    const { nextMain, payload } = productPageContent(next, href, href);
    const rendered = mainSectionIds(nextMain);
    const canonical = next.head.querySelector('link[rel="canonical"]')?.href;
    const productId = next.head.querySelector('meta[name="alac-navigation-product-id"]')?.content;
    if (!rendered || rendered.length !== ids.length || rendered.some((id, i) => id !== ids[i])
      || !next.title.trim() || !samePath(canonical, href, href) || new URL(canonical, href).origin !== new URL(href).origin || String(payload.id) !== productId
      || !next.head.querySelector('meta[property="og:title"]') || !next.head.querySelector('meta[property="og:url"]')) throw new Error('Incomplete product sections');
  }
  async function requestProductPage(href, options, { fetchImpl, sectionIds, parseDocument } = {}) {
    if (!sectionIds?.length) return fetchImpl(href, options);
    const controller = new AbortController();
    const abort = () => controller.abort();
    options.signal?.addEventListener('abort', abort, { once: true });
    if (options.signal?.aborted) controller.abort();
    try {
      const parts = await Promise.all(sectionRequestUrls(href, sectionIds).map(async url => {
        const response = await fetchImpl(url.href, {
          // Shopify product routes can negotiate product JSON before processing sections when
          // Accept is application/json. Request HTML; the sections endpoint still responds with JSON.
          ...options, signal: controller.signal, headers: { ...options.headers, Accept: 'text/html' }
        });
        if (!response.ok || !String(response.headers.get('content-type') || '').includes('application/json')
          || !samePath(response.url, href, href) || new URL(response.url).origin !== new URL(href).origin) throw new Error('Invalid section response');
        return response.json();
      }));
      const html = sectionPageHtml(Object.assign({}, ...parts), sectionIds, href);
      validateSectionPage(parseDocument(html), sectionIds, href);
      return { ok: true, url: href, headers: { get: name => name.toLowerCase() === 'content-type' ? 'text/html' : null }, text: async () => html };
    } catch (error) {
      controller.abort();
      if (options.signal?.aborted) throw error;
      // Missing sections, a different template, or invalid metadata use the complete existing page.
      return fetchImpl(href, options);
    } finally {
      options.signal?.removeEventListener('abort', abort);
    }
  }
  function productRoute(scope) { return scope?.querySelector('product-info')?.dataset.url || null; }
  // The Junip reviews section is the target of the stars link and "Read all reviews"; its id is set
  // by script (the apps section cannot carry one), so it is set again after main is replaced.
  function markReviews(doc) {
    const target = doc?.querySelector('.junipreviewsection') || doc?.querySelector('.junip-product-review');
    if (target && !doc.getElementById('alac-all-reviews')) target.id = 'alac-all-reviews';
    return target || null;
  }
  function removeProductModals(scope, body) {
    const section = scope?.dataset.section;
    if (!section || !body) return 0;
    const owned = [...body.querySelectorAll('product-modal[data-alac-product-modal], modal-dialog[data-alac-product-modal]')]
      .filter(node => node.dataset.alacProductModal === section);
    owned.forEach(node => {
      if (node.hasAttribute('open')) node.hide();
      node.remove();
    });
    return owned.length;
  }

  // The related product a format or grind control points to, read from its picker's JSON.
  function labelTarget(label, currentHref, base) {
    const picker = label?.closest?.('.custom-picker__container-all');
    let items;
    try { items = JSON.parse(picker.querySelector('.relatedItems-json').textContent).RelatedProducts; }
    catch (_) { return null; }
    const format = label.closest('.custom-options__option') ? label.dataset.value : null;
    const grind = label.closest('.custom-options__grind') ? label.dataset.value : null;
    const target = relatedTarget(items, currentHref, format, grind, base);
    return target?.Url ? { target, format, grind } : null;
  }

  // Keep recently fetched sibling pages briefly so format and grind switches can reuse their HTML.
  // The parsed nodes are moved into the live page, so cache the response text instead of a document.
  function createPrefetcher({ fetchImpl, base, limit = 8, maxAge = 2 * 60 * 1000, now = () => Date.now() } = {}) {
    const entries = new Map();
    function get(href) {
      const entry = entries.get(href);
      if (!entry) return null;
      if (!entry.promise && now() - entry.at > maxAge) { entries.delete(href); return null; }
      return entry;
    }
    function store(href, html) {
      if (!href || typeof html !== 'string' || !html) return;
      entries.delete(href);
      entries.set(href, { at: now(), html });
      for (const key of entries.keys()) {
        if (entries.size <= limit) break;
        if (!entries.get(key).promise) entries.delete(key);
      }
    }
    function drop(href) { entries.delete(href); }
    function sameOrigin(href) {
      if (!base) return true;
      try { return new URL(href, base).origin === new URL(base).origin; } catch (_) { return false; }
    }
    function prefetch(href) {
      if (!href || get(href) || typeof fetchImpl !== 'function' || !sameOrigin(href)) return null;
      const promise = Promise.resolve()
        .then(() => fetchImpl(href, { credentials: 'same-origin', headers: { Accept: 'text/html' }, priority: 'low' }))
        .then(response => (validProductResponse(response, href, base) ? response.text() : null))
        .catch(() => null)
        .then(html => {
          if (entries.get(href)?.promise === promise) {
            entries.delete(href);
            if (typeof html === 'string' && html) store(href, html);
          }
          return typeof html === 'string' && html ? html : null;
        });
      entries.set(href, { at: now(), promise });
      return promise;
    }
    // The cached HTML (or the in-flight prefetch for it) as a promise, or null when nothing is held.
    function take(href) {
      const entry = get(href);
      if (!entry) return null;
      return entry.promise || Promise.resolve(entry.html);
    }
    return { prefetch, take, store, drop, has: href => !!get(href), get size() { return entries.size; } };
  }

  // A speculative request can stall before the shopper selects it. Bound the active wait and
  // settle it immediately when a later choice supersedes it, even if that request has no signal.
  function waitForNavigation(promise, signal, timeoutMs = 15000) {
    return new Promise((resolve, reject) => {
      let settled = false;
      const finish = (callback, value) => {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        signal.removeEventListener('abort', aborted);
        callback(value);
      };
      const aborted = () => {
        const error = new Error('Product navigation was cancelled');
        error.name = 'AbortError';
        finish(reject, error);
      };
      const timer = setTimeout(() => finish(reject, new Error('Product request timed out')), timeoutMs);
      signal.addEventListener('abort', aborted, { once: true });
      if (signal.aborted) aborted();
      Promise.resolve(promise).then(value => finish(resolve, value), error => finish(reject, error));
    });
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { samePath, relatedTarget, packCount, restoredQuantity, incomingPurchaseState, singleVariantQuantityInput, targetUrl, validProductResponse, mainSectionIds, sectionRequestUrls, sectionPageHtml, productPageContent, validateSectionPage, requestProductPage, productRoute, removeProductModals, productViewedPayload, publishView, markReviews, labelTarget, createPrefetcher, waitForNavigation };
    return;
  }
  if (root.alacPdpNavigation) return;

  let sequence = 0;
  let pending = null;
  let pendingTarget = null;
  let currentItem = null;
  let stateTimer = null;
  const cartItems = new Map();
  function fetchProductPage(href, options) {
    const ids = document.body?.classList?.contains('product') ? mainSectionIds(document.querySelector('main#MainContent')) : null;
    return requestProductPage(href, options, {
      fetchImpl: (url, settings) => fetch(url, settings), sectionIds: ids,
      parseDocument: html => new DOMParser().parseFromString(html, 'text/html')
    });
  }
  const prefetcher = createPrefetcher({ fetchImpl: fetchProductPage, base: typeof location !== 'undefined' ? location.origin : undefined });

  function productRoot(scope = document) { return scope.querySelector('.alac-pdp[id^="MainProduct-"]'); }
  function productData(scope = document) {
    try { return JSON.parse(productRoot(scope)?.querySelector('[data-alac-product]')?.textContent || 'null'); }
    catch (_) { return null; }
  }
  function analyticsItem(scope = document) {
    try { return JSON.parse(productRoot(scope)?.querySelector('[data-alac-analytics]')?.textContent || 'null'); }
    catch (_) { return null; }
  }
  // Shopify's standard product_viewed pixel event is published by Shopify on a full page load only and is
  // reserved: theme code cannot emit standard events. After an in-place format switch the page publishes a
  // custom event instead, which a custom pixel can subscribe to (analytics.subscribe('alac_product_viewed')).
  function productViewedPayload(item, product) {
    if (!item || !product) return null;
    const variant = product.variants?.find(v => v.available) || product.variants?.[0];
    return {
      productVariant: variant ? {
        id: String(variant.id), title: variant.title,
        price: { amount: variant.price / 100, currencyCode: product.currency },
        product: { id: String(item.ProductID), title: item.Name, vendor: item.Brand, url: item.URL }
      } : null
    };
  }
  function publishView(item, product, analytics) {
    const payload = productViewedPayload(item, product);
    if (!payload || !analytics || typeof analytics.publish !== 'function') return false;
    try { analytics.publish('alac_product_viewed', payload); return true; } catch (_) { return false; }
  }
  function trackView(navigated = false) {
    const item = analyticsItem();
    if (!item || item.ProductID === currentItem?.ProductID) return;
    currentItem = item;
    if (navigated) publishView(item, productData(), root.Shopify?.analytics);
    const queue = root._learnq = root._learnq || [];
    queue.push(['track', 'Viewed Product', item]);
    queue.push(['trackViewedItem', {
      Title: item.Name, ItemId: item.ProductID, Categories: item.Categories,
      ImageUrl: item.ImageURL, Url: item.URL,
      Metadata: { Brand: item.Brand, Price: item.Price, CompareAtPrice: item.CompareAtPrice }
    }]);
  }
  function selectedQuantity(scope) {
    const form = scope.querySelector('product-form form');
    return singleVariantQuantityInput(scope)
      || [...scope.querySelectorAll('[name="quantity"]')].find(input => input.form === form)
      || form?.querySelector('[name="quantity"]');
  }
  function capture(scope = productRoot()) {
    if (!scope) return null;
    const checked = scope.querySelector('variant-radios input:checked');
    return {
      custom: !!checked?.closest('.option-container-custom'),
      singleVariantQuantity: !!singleVariantQuantityInput(scope),
      pack: checked ? packCount(checked.value) : 1,
      quantity: Math.max(1, Number(selectedQuantity(scope)?.value) || 1),
      subscribed: scope.querySelector('[name="tabinner"]:checked')?.value === 'subscribeandsave',
      weeks: root.AlacSubscriptionPricing?.selectedWeeks(scope) || null,
      variantId: scope.querySelector('product-form [name="id"]')?.value || null
    };
  }
  function saveCurrentState() {
    if (pending) return;
    const scope = productRoot();
    if (scope && samePath(location.href, productRoute(scope), location.origin)) {
      history.replaceState({ ...history.state, alacPdp: capture(scope) }, '', location.href);
    }
  }
  function scheduleStateSave() {
    clearTimeout(stateTimer);
    stateTimer = setTimeout(saveCurrentState, 0);
  }
  function chooseRadio(radio) {
    if (!radio || radio.disabled) return false;
    if (!radio.checked) radio.click();
    return true;
  }
  function restore(scope, state) {
    if (!scope || !state) return;
    const tiles = [...scope.querySelectorAll('.option-container-size input[type="radio"][data-vid]')].filter(radio => !radio.disabled && !radio.classList.contains('disabled'));
    const exact = tiles.find(radio => String(radio.dataset.vid) === String(state.variantId));
    const size = tiles.find(radio => packCount(radio.value) === state.pack);
    const first = tiles[0];
    const customRadio = scope.querySelector('.option-container-custom input[type="radio"]');
    const customAvailable = !!customRadio && !!first && !customRadio.disabled && !customRadio.classList.contains('disabled') && !customRadio.closest('.disabled');
    const singleVariantAvailable = !!singleVariantQuantityInput(scope);
    if (state.custom && customAvailable) {
      chooseRadio(first);
      chooseRadio(customRadio);
    } else chooseRadio(exact || size || first);
    const quantity = selectedQuantity(scope);
    if (quantity) {
      quantity.value = restoredQuantity(state, customAvailable, singleVariantAvailable);
      // QuantityInput updates its +/- state directly. Bubbling this event through variant-radios
      // would trigger a redundant Shopify section fetch for a variant that did not change.
      quantity.dispatchEvent(new Event('change'));
    }
    const picker = scope.querySelector('.recharge-picker__container');
    if (picker && state.weeks) {
      const labels = [...picker.querySelectorAll('.recharge-option label')];
      const match = labels.find(label => root.AlacSubscriptionPricing?.weeks(label.dataset.value) === state.weeks);
      if (match) root.AlacSubscriptionPricing?.selectCadence(picker, match);
      else if (state.weeks >= 1 && state.weeks <= 12) {
        const custom = labels.find(label => label.dataset.value === 'custom');
        const weeks = picker.querySelector('[name="weeks"]');
        if (custom && weeks) { weeks.value = state.weeks; root.AlacSubscriptionPricing?.selectCadence(picker, custom); }
      }
    }
    chooseRadio(scope.querySelector('[name="tabinner"][value="' + (state.subscribed ? 'subscribeandsave' : 'buyonce') + '"]'));
    root.AlacSubscriptionPricing?.sync(scope);
    root.alacPdpValueRefresh?.();
  }
  function markCurrent(scope = productRoot()) {
    const picker = scope?.querySelector('.custom-picker__container-all');
    if (!picker) return;
    let items;
    try { items = JSON.parse(picker.querySelector('.relatedItems-json').textContent).RelatedProducts; }
    catch (_) { return; }
    const current = items.find(item => samePath(item.Url, location.href, location.origin));
    if (!current) return;
    // Format and grind are radio inputs inside their labels; the label class drives the visual state.
    const mark = (label, selected) => {
      label.classList.toggle('selected', selected);
      const input = label.querySelector('input[type="radio"]');
      if (input) input.checked = selected;
    };
    picker.querySelectorAll('.custom-options__option .toggle-button').forEach(label => mark(label, label.dataset.value === String(current.Type || '').toLowerCase()));
    picker.querySelectorAll('.custom-options__grind .toggle-button').forEach(label => mark(label, label.dataset.value === String(current.Grind || '').toLowerCase()));
  }
  function clearError() { document.querySelector('[data-alac-nav-error]')?.remove(); }
  function showError(url) {
    clearError();
    const picker = productRoot()?.querySelector('.custom-picker__container-all');
    if (!picker) return;
    const message = document.createElement('p');
    message.dataset.alacNavError = '';
    message.setAttribute('role', 'alert');
    message.append('Could not load this format. ');
    const link = document.createElement('a'); link.href = url; link.textContent = 'Open the product page';
    message.append(link);
    picker.after(message);
  }
  function busy(value) {
    const scope = productRoot();
    if (!scope) return;
    scope.setAttribute('aria-busy', String(value));
    scope.querySelectorAll('variant-radios, .oc__subscription-tabinner-box, .recharge-picker__container, product-form').forEach(node => { node.inert = value; });
    let status = scope.querySelector('[data-alac-nav-status]');
    if (!value) { status?.remove(); return; }
    if (!status) {
      status = document.createElement('p');
      status.dataset.alacNavStatus = '';
      status.setAttribute('role', 'status');
      scope.querySelector('.custom-picker__container-all')?.after(status);
    }
    status.textContent = 'Loading coffee format…';
  }
  function updateHead(next) {
    document.title = next.title;
    ['link[rel="canonical"]', 'meta[name="description"]', 'meta[property^="og:"]', 'meta[name^="twitter:"]'].forEach(selector => {
      next.head.querySelectorAll(selector).forEach(source => {
        const key = source.getAttribute('property') || source.getAttribute('name') || source.getAttribute('rel');
        const current = [...document.head.querySelectorAll(selector)].find(node => (node.getAttribute('property') || node.getAttribute('name') || node.getAttribute('rel')) === key);
        if (current) current.replaceWith(source.cloneNode(true));
      });
    });
  }
  function afterPaint(run, callback) {
    if (typeof root.requestAnimationFrame !== 'function') { callback(); return; }
    root.requestAnimationFrame(() => setTimeout(() => {
      if (run === sequence && productRoot()) callback();
    }, 0));
  }
  async function navigate(input, { replace = false, restoreState = null, focusChoice = null } = {}) {
    const url = targetUrl(input, location.href);
    if (!url) { showError(input); return; }
    if (pending) pending.abort();
    const run = ++sequence;
    const controller = pending = new AbortController();
    pendingTarget = url;
    let committed = false;
    let succeeded = false;
    clearError(); busy(true);
    const originState = capture();
    if (!replace) history.replaceState({ ...history.state, alacPdp: originState }, '', location.href);
    try {
      // Reuse a warmed page or an in-flight request for the selected product.
      const html = await waitForNavigation((async () => {
        const cached = prefetcher.take(url.href);
        let content = cached ? await cached : null;
        if (run !== sequence || controller.signal.aborted) return null;
        if (!content) {
          const response = await fetchProductPage(url.href, { signal: controller.signal, credentials: 'same-origin', headers: { Accept: 'text/html' } });
          if (!validProductResponse(response, url.href, location.origin)) throw new Error('Invalid product response');
          content = await response.text();
          if (run === sequence && !controller.signal.aborted) prefetcher.store(url.href, content);
        }
        return content;
      })(), controller.signal);
      if (run !== sequence) return;
      const next = new DOMParser().parseFromString(html, 'text/html');
      if (run !== sequence) return;
      const { nextMain } = productPageContent(next, url.href, location.origin);
      const currentMain = document.querySelector('main#MainContent');
      if (!currentMain) throw new Error('Missing current content');
      root.alacPdpValueUnmount?.();
      root.alacPdpStoryReviews?.unmount();
      root.alacDeliveryEstimateUnmount?.(currentMain);
      removeProductModals(productRoot(currentMain), document.body);
      // DOMParser parses with scripting disabled, so noscript fallback controls become real
      // form-associated elements. Do not adopt those duplicate variant selectors into the live PDP.
      nextMain.querySelectorAll('noscript').forEach(node => node.remove());
      committed = true;
      currentMain.replaceChildren(...nextMain.childNodes);
      updateHead(next);
      if (replace) history.replaceState({ ...history.state, alacPdp: restoreState }, '', url.href);
      else history.pushState({ alacPdp: null }, '', url.href);
      root.alacPdpValuePrepareLayout?.(productRoot()?.querySelector('product-info'));
      root.alacInitProductSection?.(productRoot());
      restore(productRoot(), restoreState || originState);
      root.alacPdpValueRefresh?.();
      markCurrent();
      markReviews(document);
      trackView(true);
      history.replaceState({ ...history.state, alacPdp: capture() }, '', location.href);
      document.dispatchEvent(new CustomEvent('alac:pdp:navigated', { detail: { product: productData(), url: location.href } }));
      succeeded = true;
    } catch (error) {
      if (run !== sequence || error.name === 'AbortError') return;
      controller.abort();
      prefetcher.drop(url.href);
      console.warn('ALAC PDP navigation failed', error);
      if (replace || committed) location.assign(url.href);
      else showError(url.href);
    } finally {
      if (run === sequence) {
        pending = null; pendingTarget = null; busy(false);
        if (succeeded && focusChoice) {
          const selector = focusChoice.kind === 'format' ? '.custom-options__option .toggle-button' : '.custom-options__grind .toggle-button';
          const choice = [...(productRoot()?.querySelectorAll(selector) || [])].find(node => node.dataset.value === focusChoice.value);
          if (choice?.isConnected) (choice.querySelector?.('input[type="radio"]') || choice).focus();
        }
        if (succeeded) afterPaint(run, () => {
          root.alacDeliveryEstimateStart?.();
          root.alacPdpStoryReviews?.mount();
          root.alacInitProductFaq?.();
          try { root.junip?.init?.(); } catch (error) { console.warn('Junip reinitialization failed', error); }
          try { root.Shopify?.PaymentButton?.init?.(); } catch (error) { console.warn('Payment button reinitialization failed', error); }
        });
      }
    }
  }
  function onClick(event) {
    const label = event.target.closest?.('.alac-pdp .custom-picker__container .toggle-button');
    if (!label) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (label.classList.contains('disabled')) return;
    const found = labelTarget(label, pendingTarget?.href || location.href, location.origin);
    if (!found) return;
    const { target, format, grind } = found;
    if (samePath(target.Url, location.href, location.origin)) {
      if (pending) { pending.abort(); pending = null; pendingTarget = null; sequence += 1; busy(false); }
      return;
    }
    navigate(target.Url, { focusChoice: event.detail === 0 ? { kind: format ? 'format' : 'grind', value: format || grind } : null });
  }
  document.addEventListener('click', onClick, true);
  // Warm the target when a shopper points to or focuses a choice.
  function onIntent(event) {
    const label = event.target?.closest?.('.alac-pdp .custom-picker__container .toggle-button');
    if (!label || pending || label.classList.contains('disabled') || label.classList.contains('selected')) return;
    if (typeof navigator !== 'undefined' && navigator.connection?.saveData) return;
    const found = labelTarget(label, location.href, location.origin);
    if (!found || samePath(found.target.Url, location.href, location.origin)) return;
    const url = targetUrl(found.target.Url, location.href);
    if (url) prefetcher.prefetch(url.href);
  }
  document.addEventListener('mouseover', onIntent, { passive: true });
  document.addEventListener('focusin', onIntent);
  document.addEventListener('touchstart', onIntent, { passive: true });
  function warmRelated() {
    if (navigator.connection?.saveData || /(^|-)2g$/.test(navigator.connection?.effectiveType || '')) return;
    const picker = productRoot()?.querySelector('.custom-picker__container-all');
    let items;
    try { items = JSON.parse(picker?.querySelector('.relatedItems-json')?.textContent).RelatedProducts; }
    catch (_) { return; }
    const current = items.find(item => samePath(item.Url, location.href, location.origin));
    if (!current) return;
    const ordered = items.filter(item => !samePath(item.Url, location.href, location.origin)).sort((a, b) => {
      const rank = item => item.Type === current.Type ? 0 : item.Grind === current.Grind ? 1 : 2;
      return rank(a) - rank(b);
    });
    (async () => {
      for (const item of ordered) {
        if (!productRoot() || !samePath(location.href, productRoute(productRoot()), location.origin)) break;
        const url = targetUrl(item.Url, location.href);
        if (url && !prefetcher.has(url.href)) await prefetcher.prefetch(url.href);
      }
    })();
  }
  function scheduleWarmRelated() {
    const start = () => {
      if (typeof root.requestIdleCallback === 'function') root.requestIdleCallback(warmRelated, { timeout: 3000 });
      else setTimeout(warmRelated, 800);
    };
    if (document.readyState === 'complete') start();
    else root.addEventListener('load', start, { once: true });
  }
  scheduleWarmRelated();
  document.addEventListener('change', event => {
    if (event.target.closest?.('.alac-pdp') && (event.target.closest('variant-radios') || ['id', 'quantity', 'weeks', 'tabinner'].includes(event.target.name))) scheduleStateSave();
  });
  document.addEventListener('input', event => {
    if (event.target.closest?.('.alac-pdp') && ['quantity', 'weeks'].includes(event.target.name)) scheduleStateSave();
  });
  document.addEventListener('click', event => {
    if (event.target.closest?.('.alac-pdp .recharge-option, .alac-pdp .btn-close__selector')) scheduleStateSave();
  });
  document.addEventListener('submit', event => {
    if (!event.target.closest('.alac-pdp')) return;
    if (pending) { event.preventDefault(); event.stopImmediatePropagation(); return; }
    const id = event.target.querySelector('[name="id"]')?.value;
    const item = analyticsItem();
    if (id && item) cartItems.set(String(id), item);
  }, true);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
      if (event?.source !== 'product-form') return;
      const id = String(event.productVariantId);
      const item = cartItems.get(id);
      cartItems.delete(id);
      if (item) (root._learnq = root._learnq || []).push(['track', 'Added to Cart', item]);
    });
    subscribe(PUB_SUB_EVENTS.cartError, event => { if (event?.productVariantId) cartItems.delete(String(event.productVariantId)); });
  }
  root.addEventListener('popstate', event => {
    const scope = productRoot();
    if (!scope) return;
    if (!samePath(location.href, productRoute(scope), location.origin)) {
      navigate(location.href, { replace: true, restoreState: event.state?.alacPdp || null });
    } else if (pending) {
      // Forward can return to the still-rendered product before the preceding Back request ends.
      pending.abort(); pending = null; pendingTarget = null; sequence += 1; busy(false);
    }
  });
  root.alacPdpNavigation = { navigate, capture, markCurrent, prefetcher };
  function restoreIncomingPurchase() {
    const scope = productRoot();
    if (!scope) return;
    const href = location.href;
    const product = root.AlacSubscriptionPricing?.read(scope);
    const state = incomingPurchaseState(href, product, scope.querySelector('product-form [name="id"]')?.value);
    if (!state) return;
    root.alacInitProductSection?.(scope);
    state.singleVariantQuantity = !!singleVariantQuantityInput(scope);
    const customRadio = scope.querySelector('.option-container-custom input[type="radio"]');
    const variant = product.variants.find(item => String(item.id) === state.variantId);
    // The Custom radio carries its option value, without a data-vid. Hidden single steep bags
    // must retain that selection even at quantity one or when an incoming plan is rejected.
    if (customRadio?.value === variant.title
      && ![...scope.querySelectorAll('.option-container-size input[data-vid]')].some(input => String(input.dataset.vid) === state.variantId)) state.custom = true;
    restore(scope, state);
    root.alacPdpNavigation.incomingRestored = true;
    // Consume this handoff once. Otherwise a later reload can reapply the original subscription
    // and quantity after the shopper has changed them. Keep variant, preview and campaign context.
    const consumed = new URL(href);
    consumed.searchParams.delete('quantity');
    consumed.searchParams.delete('selling_plan');
    history.replaceState({ ...history.state }, '', consumed.href);
    saveCurrentState();
  }
  function init() {
    markCurrent(); trackView();
    // Apply the incoming order as soon as the controls are usable. Images and third-party widgets
    // can delay window.load while a shopper already changes format or submits the product form.
    restoreIncomingPurchase();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})(typeof window !== 'undefined' ? window : globalThis);
